import { render, staticRenderFns } from "./TransitionStack.vue?vue&type=template&id=782a6f45&"
import script from "./TransitionStack.vue?vue&type=script&lang=js&"
export * from "./TransitionStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports